export const ApplicationName = 'manulife_proposal_builder';

export const QueryParameterNames = {
  ReturnUrl: 'returnUrl',
  Message: 'message'
};

export const LogoutActions = {
  LogoutCallback: 'logout-callback',
  Logout: 'logout',
  LoggedOut: 'logged-out'
};

export const LoginActions = {
  Login: 'login',
  LoginCallback: 'login-callback',
  LoginFailed: 'login-failed',
  Profile: 'profile',
  Register: 'register'
};

const prefix = '/authentication';

export const ApplicationPaths = {
    DefaultLoginRedirectPath: '/proposal-builder/',
    ApiAuthorizationClientConfigurationUrl: `/proposal-builder/_configuration/${ApplicationName}`,
    ApiAuthorizationPrefix: prefix,
    Login: `${prefix}/${LoginActions.Login}`,
    LoginFailed: `${prefix}/${LoginActions.LoginFailed}`,
    LoginCallback: `${prefix}/${LoginActions.LoginCallback}`, 
    Register: `${prefix}/${LoginActions.Register}`,
    Profile: `${prefix}/${LoginActions.Profile}`,
    LogOut: `${prefix}/${LogoutActions.Logout}`,
    LoggedOut: `/proposal-builder${prefix}/${LogoutActions.LoggedOut}`,
    LogOutCallback: `/proposal-builder${prefix}/${LogoutActions.LogoutCallback}`,
    IdentityRegisterPath: '/proposal-builder/Identity/Account/Register',
    IdentityManagePath: '/proposal-builder/Identity/Account/Manage'
};
